import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>IT Policy</h1>
                <p>Home &gt; IT Policy</p>
            </div>
        </div>
    )
}

export default Hero;